export default {
   tips: '请浏览凯尔克一系列的产品手册，了解有关凯尔克产品规格和服务的更多信息',
   title1:'上传时间'
}


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/information.js